var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "grouped-summary p-3 mb-3" }, [
    _c("div", { staticClass: "row align-items-center summary-row" }, [
      _c("div", { staticClass: "col-12 col-md-4 summary-item px-4" }, [
        _c("div", { staticClass: "color-black font-14" }, [
          _vm._v("Total de Pagos Procesados:")
        ]),
        _c(
          "div",
          { staticClass: "color-black font-weight-bold font-20 mt-1" },
          [_vm._v(" " + _vm._s(_vm.value.totalProcessedPayments) + " ")]
        )
      ]),
      _c("div", { staticClass: "col-12 col-md-4 summary-item mt-3 mt-md-0" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex align-items-center justify-content-between px-4"
          },
          [
            _c("div", [
              _c("div", { staticClass: "color-black font-14" }, [
                _vm._v(" Total de Estudiantes Procesados: ")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-20 mt-1" },
                [_vm._v(" " + _vm._s(_vm.value.totalProcessedStudents) + " ")]
              )
            ]),
            _c(
              "svg",
              {
                staticClass: "summary-donut",
                attrs: {
                  viewBox: "0 0 36 36",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("circle", {
                  staticClass: "donut-track",
                  attrs: {
                    cx: "18",
                    cy: "18",
                    fill: "none",
                    r: "15.9",
                    stroke: "#e9ecef",
                    "stroke-width": "3.2"
                  }
                }),
                _c("circle", {
                  staticClass: "donut-segment",
                  attrs: {
                    cx: "18",
                    cy: "18",
                    fill: "none",
                    r: "15.9",
                    stroke: "#FDAC41",
                    "stroke-dasharray": "100 0",
                    "stroke-dashoffset": "25",
                    "stroke-linecap": "round",
                    "stroke-width": "3.2"
                  }
                }),
                _c(
                  "text",
                  {
                    staticClass: "donut-label",
                    attrs: {
                      "dominant-baseline": "middle",
                      fill: "#333",
                      "font-size": "8",
                      "font-weight": "bold",
                      "text-anchor": "middle",
                      x: "18",
                      y: "18"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.processedPercent) + "% ")]
                )
              ]
            )
          ]
        )
      ]),
      _c("div", { staticClass: "col-12 col-md-4 summary-item mt-3 mt-md-0" }, [
        _c(
          "div",
          {
            staticClass:
              "d-flex align-items-center justify-content-between px-4"
          },
          [
            _c("div", [
              _c("div", { staticClass: "color-black font-14" }, [
                _vm._v(" Total de Estudiantes Pagados: ")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-20 mt-1" },
                [_vm._v(" " + _vm._s(_vm.value.totalPaidStudents) + " ")]
              )
            ]),
            _c(
              "svg",
              {
                staticClass: "summary-donut",
                attrs: {
                  viewBox: "0 0 36 36",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("circle", {
                  staticClass: "donut-track",
                  attrs: {
                    cx: "18",
                    cy: "18",
                    fill: "none",
                    r: "15.9",
                    stroke: "#e9ecef",
                    "stroke-width": "3.2"
                  }
                }),
                _c("circle", {
                  staticClass: "donut-segment",
                  attrs: {
                    cx: "18",
                    cy: "18",
                    fill: "none",
                    r: "15.9",
                    stroke: _vm.paidPercent > 0 ? "#FDAC41" : "#E1E1E1",
                    "stroke-dasharray": `${_vm.paidPercent} ${100 -
                      _vm.paidPercent}`,
                    "stroke-dashoffset": "25",
                    "stroke-linecap": "round",
                    "stroke-width": "3.2"
                  }
                }),
                _c(
                  "text",
                  {
                    staticClass: "donut-label",
                    attrs: {
                      "dominant-baseline": "middle",
                      fill: "#333",
                      "font-size": "8",
                      "font-weight": "bold",
                      "text-anchor": "middle",
                      x: "18",
                      y: "18"
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.paidPercent) + "% ")]
                )
              ]
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }